/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React from "react";

interface RatingIconProps {
  index: number;
  rating: number;
  hoverRating: number;
  onMouseEnter(n: number): void;
  onMouseLeave(): void;
  onSaveRating(n: number): void;
}

function RatingIcon(props: RatingIconProps) {
  const {
    index,
    rating,
    hoverRating,
    onMouseEnter,
    onMouseLeave,
    onSaveRating,
  } = props;
  if (hoverRating >= index || (!hoverRating && rating >= index)) {
    return (
      <span
        style={{ cursor: "pointer" }}
        className="rating-btn active"
        onClick={() => onSaveRating(index)}
        onMouseEnter={() => onMouseEnter(index)}
        onMouseLeave={() => onMouseLeave()}
      ></span>
    );
  } else {
    return (
      <span
        style={{ cursor: "pointer" }}
        className="rating-btn"
        onClick={() => onSaveRating(index)}
        onMouseEnter={() => onMouseEnter(index)}
        onMouseLeave={() => onMouseLeave()}
      ></span>
    );
  }
}

export default RatingIcon;
